exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiselect-sm{font-size:13px!important;.multiselect__select{font-size:13px!important;height:31px!important}.multiselect__placeholder{margin-bottom:4px!important}.multiselect__tags{min-height:0!important;padding:4px 40px 0 8px!important}.multiselect__content-wrapper{max-height:180px!important}}.dropdown-menu{max-height:200px;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f09a545","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/ReservationWidget.vue
// module id = 899
// module chunks = 0